// src/pages/Tarifs/components/PricingHubSimple.jsx

import React, { useMemo, useState } from "react";

import Reveal from "../../../components/ui/Reveal";

import PricingApplicationSelector from "./PricingApplicationSelector";
import PricingCard from "./PricingCard";

import {
  PRICING_APPLICATIONS,
} from "../data/pricingCatalog";

import {
  getApplicationsByCategory,
} from "../utils/pricingUtils";

export default function PricingHubSimple() {
  const [activeCategory, setActiveCategory] = useState("clubs");
  const [selectedApplicationId, setSelectedApplicationId] =
    useState(null);

  const visibleApplications = useMemo(() => {
    return getApplicationsByCategory(
      PRICING_APPLICATIONS,
      activeCategory,
    );
  }, [activeCategory]);

  const selectedApplication = useMemo(() => {
    return PRICING_APPLICATIONS.find(
      (application) =>
        application.id === selectedApplicationId,
    );
  }, [selectedApplicationId]);

  const handleCategoryChange = (categoryId) => {
    setActiveCategory(categoryId);
    setSelectedApplicationId(null);
  };

  const handleApplicationSelect = (applicationId) => {
    setSelectedApplicationId(applicationId);

    window.requestAnimationFrame(() => {
      window.setTimeout(() => {
        document
          .getElementById("selected-pricing")
          ?.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
      }, 120);
    });
  };

  return (
    <div className="py-16 sm:py-20 lg:py-24">
      <div className="mx-auto max-w-[1320px]">
        <Reveal>
          <div className="grid gap-7 border-b border-slate-200 pb-10 dark:border-white/10 lg:grid-cols-[1.05fr_0.95fr] lg:items-end">
            <div>
              <p className="text-xs font-semibold uppercase tracking-[0.22em] text-[#0868f2] dark:text-blue-300">
                Tarifs MonAppliClub
              </p>

              <h1 className="mt-5 max-w-4xl text-4xl font-semibold leading-[1.08] tracking-[-0.045em] text-slate-950 dark:text-white sm:text-5xl lg:text-6xl">
                Choisissez votre application,
                <span className="block text-[#0868f2] dark:text-blue-300">
                  découvrez ensuite son tarif.
                </span>
              </h1>
            </div>

            <div className="max-w-xl lg:justify-self-end">
              <p className="text-base leading-8 text-slate-600 dark:text-slate-300">
                Pas de tableau compliqué ni de comparaison interminable.
                Sélectionnez votre type de structure, puis l’application qui
                correspond à votre besoin.
              </p>

              <div className="mt-5 flex flex-wrap gap-x-6 gap-y-2 text-xs font-semibold uppercase tracking-[0.14em] text-slate-400">
                <span>
                  <strong className="mr-2 text-[#ff7900]">01</strong>
                  Votre structure
                </span>

                <span>
                  <strong className="mr-2 text-[#ff7900]">02</strong>
                  Votre application
                </span>

                <span>
                  <strong className="mr-2 text-[#ff7900]">03</strong>
                  Son tarif
                </span>
              </div>
            </div>
          </div>
        </Reveal>

        <Reveal className="mt-10">
          <PricingApplicationSelector
            applications={visibleApplications}
            activeCategory={activeCategory}
            selectedApplicationId={selectedApplicationId}
            onCategoryChange={handleCategoryChange}
            onApplicationSelect={handleApplicationSelect}
          />
        </Reveal>

        {selectedApplication ? (
          <Reveal className="mt-14">
            <PricingCard application={selectedApplication} />
          </Reveal>
        ) : (
          <Reveal className="mt-12">
            <div className="flex flex-col gap-3 border-y border-slate-200 py-7 dark:border-white/10 sm:flex-row sm:items-center sm:justify-between">
              <p className="text-sm text-slate-500 dark:text-slate-400">
                Sélectionnez une application pour afficher uniquement sa
                formule et ce qui est inclus.
              </p>

              <span className="text-xs font-semibold uppercase tracking-[0.16em] text-[#ff7900]">
                Aucun tarif affiché pour le moment
              </span>
            </div>
          </Reveal>
        )}
      </div>
    </div>
  );
}